import { Icon, IconProps } from "../";

export const ComplexionIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.47733 6.47733 2 12 2C17.5227 2 22 6.47733 22 12C22 17.5227 17.5227 22 12 22C6.47733 22 2 17.5227 2 12ZM8.47067 11.9706C7.65867 11.9706 7 11.312 7 10.5C7 9.68796 7.65867 9.0293 8.47067 9.0293C9.28267 9.0293 9.94133 9.68796 9.94133 10.5C9.94133 11.312 9.28267 11.9706 8.47067 11.9706ZM14.0587 10.5C14.0587 11.312 14.7173 11.9706 15.5293 11.9706C16.3413 11.9706 17 11.312 17 10.5C17 9.68796 16.3413 9.0293 15.5293 9.0293C14.7173 9.0293 14.0587 9.68796 14.0587 10.5ZM9.64667 14.6173C9.64667 15.9173 10.7 16.9706 12 16.9706C13.3 16.9706 14.3533 15.9173 14.3533 14.6173H9.64667Z"
      />
    </Icon>
  );
};
